// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"f9481753","58":"9cea2f42","150":"02edfbab","152":"0cdfcd37","385":"1f617cf0","404":"2081c4b1","496":"9b3b75b4","533":"5b10ff86","605":"de8bc748","648":"f27edefe","667":"46d416a4","709":"fa137da0","954":"39933474","973":"256e8ada"}[chunkId] + ".chunk.js";
};